import { Injectable } from '@angular/core';

declare let gtag: Function;

@Injectable({
  providedIn: 'root'
})
export class GoogleAnalyticsService {

  public sendPageView(url: string) {
    gtag('config', 'G-3V6FNYP61K', {
      page_path: url,
    });
  }

  public sendEvent(eventName: string, params: any = {}) {
    gtag('event', eventName, params);
  }
}
